module.exports = __webpack_public_path__ + "static/media/home2-01.575839db.jpg";